// Brand wordmark: "Webhook" in the inherited text color + "Lens" in signal-green
// ink (--accent-ink, AA in both light and dark). Inter Tight (the app's default
// UI font) is inherited; the parent element sets size/weight/base color. Used in
// the auth headers, the sidebar, and onboarding so the wordmark reads identically
// to the vitrine (Webhook + green Lens).
export function Wordmark() {
  return (
    <>
      Webhook<span style={{ color: 'var(--accent-ink)' }}>Lens</span>
    </>
  )
}
